import { useEffect, useState } from "react";
import { LOADING_VIEW_NAME } from "../core/constants";
import { translate } from "../core/i18n";
import { store } from "../core/state";
import { getViewData } from "../core/views";

export function LoadingView() {
  const [loadingState] = store.useState(LOADING_VIEW_NAME);
  const [loadingMessage, setLoadingMessage] = useState("");  
  const [showSupport, setShowSupport] = useState(false);


  function loadNextMessage() {   
    const loadingState = getViewData(LOADING_VIEW_NAME);    
    if (loadingState.cfg?.messages && loadingState.cfg?.messages?.length > 0) {
      const messages = loadingState.cfg?.messages;
      setLoadingMessage(getRandomLoadingMessage(messages));        
    }    
    
  }

  if (loadingMessage === "app-loading") {
    loadNextMessage();
  }

  useEffect(() => {
    const meinInterval = setInterval(() => {
      loadNextMessage();
    }, 800);

    const timeOut = setTimeout(() => {
      setShowSupport(true);
    }, 10000);

    return () => {
      clearInterval(meinInterval);
      clearTimeout(timeOut);
    };
  }, []);

  const appLoading = translate("app-loading");
  const loadingTitle = appLoading === "app-loading" ? "" : appLoading;
  
  return (
    <div className="loading-container">
      <div className="text-center" style={ {marginTop : 50} }>
        <div className="mb-5">
          <h2>{ loadingTitle }</h2>
        </div>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">{ loadingTitle }</span>
        </div>
        <div className="mt-5">        
          <h5>{ loadingMessage }</h5>        
          { showSupport &&         
            <i>{ loadingState.cfg?.support }</i> 
          }
        </div>      
      </div>
    </div>
  );
}

const getRandomLoadingMessage = (messages : string[]) => {
  return messages[Math.floor(Math.random() * messages.length)];
}